
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeCargoOutlined as ObiVesselTypeCargoOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-cargo-outlined.js';
 
 
 

 
 export const ObiVesselTypeCargoOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-type-cargo-outlined',
   elementClass: ObiVesselTypeCargoOutlinedElement,
   events: {
     
   }
  });
 
 